import React, { useState, useEffect, useRef } from 'react';
import './hamburger.css';

interface HamburgerProps {
  isOpen: boolean;
  handleClick: () => void;
  dropdownContent?: React.ReactNode;
  displayText?: React.ReactNode;
}

const Hamburger: React.FC<HamburgerProps> = ({ isOpen = false, handleClick, dropdownContent, displayText }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);

  const handleDropdownClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  useEffect(() => {
    const updateDropdownPosition = () => {
      if (dropdownRef.current) {
        const rect = dropdownRef.current.getBoundingClientRect();
        const bottomSpace = window.innerHeight - rect.bottom;
        const topSpace = rect.top;

        setDropdownPosition({
          top: bottomSpace > topSpace ? '10%' : '-10%',
        });
      }
    };

    if (showDropdown) {
      updateDropdownPosition();
      window.addEventListener('resize', updateDropdownPosition);

      return () => {
        window.removeEventListener('resize', updateDropdownPosition);
      };
    }
  }, [showDropdown]);

  return (
    <div className='hamburger-outer' ref={dropdownRef}>
      <div className={`hamburger ${isOpen ? 'open' : ''}`} onClick={() => { handleClick(); setShowDropdown(!showDropdown); }}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
      {!showDropdown && <div>{displayText}</div>}
      {dropdownContent && (
        <div className={`dropdown-content ${showDropdown ? 'show' : ''}`} style={dropdownPosition}>
          {dropdownContent}
        </div>
      )}
    </div>
  );
};

export default Hamburger;
